import React from 'react';
import { Link } from 'react-router-dom';

const Sponsorship = () => {
  // Sponsorship tiers data
  const sponsorshipTiers = [
    {
      id: 1,
      name: 'Bronze Sponsor',
      price: 'Contact for Pricing',
      benefits: [
        'Logo on APN Website Event Page',
        'Recognition at APN Event',
        'Access to attendee list 2 weeks in advance',
        '1 free event registration for the organization',
        'LinkedIn sponsorship announcements',
        'Updated attendee list 3 days prior to the event'
      ]
    },
    {
      id: 2,
      name: 'Silver Sponsor',
      price: 'Contact for Pricing',
      benefits: [
        'Everything in Bronze package',
        'Access to attendee list 2.5 weeks in advance',
        '2 free event registrations for the organization',
        'Logo on event marketing emails',
        'Negotiated referral discounts on future sponsorship packages'
      ]
    },
    {
      id: 3,
      name: 'Gold Sponsor',
      price: 'Contact for Pricing',
      benefits: [
        'Everything in Silver package',
        'Access to attendee list 3 weeks in advance',
        '4 event registrations for the organization',
        '15% discount code for any additional attendees from the organization'
      ]
    }
  ];

  return (
    <div className="bg-white">
      {/* Page Header */}
      <div className="bg-apn-blue text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            {/* APN Logo */}
            <div className="flex justify-center mb-4">
              <img
                src={`${process.env.PUBLIC_URL}/apn-logos/APN-Tag-white.jpg`}
                alt="APN Logo"
                className="h-16"
              />
            </div>
            <h1 className="text-3xl font-bold">Sponsorship</h1>
          </div>
        </div>
      </div>

      {/* Sponsorship Content */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Support the APN Community</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Become a sponsor of the Accelerated Professionals Network and connect your brand with a community of finance professionals collaborating to create a more seamless M&A transaction process.
            </p>
          </div>

          <div className="mb-12">
            <p className="text-lg text-gray-600 mb-4">
              APN sponsorship provides your organization with visibility and access to a network of finance professionals at various stages of their careers. Our members include professionals from investment banking, private equity, family offices, accounting, law, and more.
            </p>
            <p className="text-lg text-gray-600 mb-4">
              By becoming a sponsor of APN or one of its events, you'll demonstrate your commitment to supporting professional development and networking in the finance industry while gaining valuable exposure for your brand.
            </p>
            <p className="text-lg text-gray-600 mb-4">
              <strong>Note:</strong> Sponsorship pricing varies by event. Please contact us for specific pricing information for upcoming events.
            </p>
            <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 mt-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Referral Program</h3>
              <p className="text-gray-700 mb-3">
                If any sponsor tier refers a specific number of attendees per event to register/attend, a proprietary discount will apply to their next sponsorship package or membership package.
              </p>
              <p className="text-gray-700">
                All sponsors receive a 5% membership or event discount referral code specific to their organization. When they reach a specific amount of referrals, the discount is applied automatically to either their membership or next sponsorship package, and they receive an Ambassador badge.
              </p>
            </div>
          </div>

          {/* Sponsorship Tiers */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {sponsorshipTiers.map((tier) => (
              <div key={tier.id} className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">
                <div className="bg-apn-blue text-white p-6">
                  <h3 className="text-2xl font-bold">{tier.name}</h3>
                  <p className="text-xl mt-2">{tier.price}</p>
                </div>
                <div className="p-6">
                  <h4 className="font-semibold text-lg mb-4">Benefits:</h4>
                  <ul className="space-y-2 mb-6">
                    {tier.benefits.map((benefit, index) => (
                      <li key={index} className="flex items-start">
                        <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <span className="text-gray-600">{benefit}</span>
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/about/contact"
                    className="block w-full bg-apn-blue text-white text-center py-2 px-4 rounded hover:bg-blue-700 transition duration-200"
                  >
                    Contact Us
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-lg text-gray-600 mb-6">
              For more information about sponsorship opportunities or to discuss custom sponsorship packages, please contact us.
            </p>
            <Link
              to="/about/contact"
              className="inline-block bg-apn-blue text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition duration-200"
            >
              Get in Touch
            </Link>
          </div>
        </div>
      </section>

      {/* Current Sponsors */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Current Sponsors</h2>
            <p className="text-lg text-gray-600">
              We're grateful for the support of these organizations that make APN's work possible.
            </p>
          </div>

          <div className="flex justify-center items-center flex-wrap gap-12">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <img
                src={`${process.env.PUBLIC_URL}/images/sponsors/hga-logo.jpg`}
                alt="Hilton Global Associates"
                className="h-24 object-contain"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = `${process.env.PUBLIC_URL}/apn-logos/APN-blue (1).png`;
                }}
              />
            </div>
            {/* Add more sponsor logos as needed */}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="bg-apn-blue text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* APN Logo */}
          <div className="flex justify-center mb-6">
            <img
              src={`${process.env.PUBLIC_URL}/apn-logos/APN-Tag-SQ-white.jpg`}
              alt="APN Logo Square"
              className="h-20"
            />
          </div>
          <h2 className="text-3xl font-bold mb-4">Become a Sponsor Today</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Support the APN community and gain visibility for your organization among finance professionals.
          </p>
          <Link to="/about/contact" className="btn-primary bg-white text-apn-blue hover:bg-gray-100">
            Contact Us About Sponsorship
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Sponsorship;
